import React from 'react';
import { Truck, Package, Heart, Wrench, Box, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { services } from '../mockData';
import { useNavigate } from 'react-router-dom';

const iconMap = {
  Truck: Truck,
  Package: Package,
  Heart: Heart,
  Wrench: Wrench,
  Box: Box
};

export const Services = () => {
  const navigate = useNavigate();
  
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-orange-500">Services</span>
          </h2>
          <p className="text-lg text-gray-600">
            Comprehensive courier and logistics solutions designed to meet your unique delivery needs with speed, reliability, and care.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            const isMedical = service.id === 3; // Medical Deliveries
            return (
              <Card 
                key={service.id} 
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 hover:border-orange-500 cursor-pointer"
                onClick={() => isMedical ? navigate('/medical-courier') : null}
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-500 transition-colors">
                    <IconComponent className="text-orange-500 group-hover:text-white transition-colors" size={32} />
                  </div>
                  <CardTitle className="text-2xl text-gray-900 group-hover:text-orange-500 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                  {isMedical && (
                    <div className="mt-4 flex items-center text-orange-500 font-semibold text-sm">
                      Learn More <ArrowRight className="ml-1 group-hover:translate-x-1 transition-transform" size={16} />
                    </div>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center border-2 border-orange-500">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Need a Custom Solution?
          </h3>
          <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
            Every business has unique logistics needs. Let's discuss how we can tailor our services to fit your requirements perfectly.
          </p>
          <Button 
            onClick={scrollToContact}
            size="lg"
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg group"
          >
            Contact Us Today
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};
